import { isNull } from 'lodash';
import { snapshot } from 'valtio';
import { logger } from 'logging-utils';
import { setShowSendSlackMessageDialog } from '../../active-issues/store-actions/issue-store-actions';
import IssuesStore from '../../active-issues/stores/issues-store';
import { getPublicChannels } from '../../../slack/api/slack-api';

export const openSendSlackMessageDialog = async () => {
  const { selectedIssue, isActiveSlackConnection } = snapshot(IssuesStore);
  setShowSendSlackMessageDialog(true);
  if (!isNull(selectedIssue) && isActiveSlackConnection) {
    try {
      await getPublicChannels({ limit: 1000, appId: selectedIssue.app.id });
    } catch (e) {
      logger.error(e);
      setShowSendSlackMessageDialog(false);
    }
  }
};
